import { Alert } from 'antd';
import React from 'react';
import { customerApiKeysApi } from '../../../api/customerApiKeysApi';
import { useShopSessionStore } from '../../../hooks/shop/useShopSessionStore';
import { useI18n } from '../../../hooks/useI18n';
import { messages } from '../../../messages';
import { CustomerApiRequestLogs as ApiRequestLogs } from '../../customerApiKeys/customerApiRequestLogs';

export function CustomerApiRequestLogs({
  apiKeyId,
  onGoBack,
}: {
  apiKeyId: number;
  onGoBack: () => void;
}) {
  const { session } = useShopSessionStore();
  const { t } = useI18n();

  if (!session.canManageCustomerApi) {
    return (
      <Alert
        type="info"
        showIcon={true}
        message={t(messages.customer.apiAccessRequired)}
      />
    );
  }

  return (
    <ApiRequestLogs
      apiKeyId={apiKeyId}
      getLogs={(page, pageSize) =>
        customerApiKeysApi.getApiKeyLogs(apiKeyId, page, pageSize)
      }
      onGoBack={onGoBack}
    />
  );
}
